import { css } from 'linaria';

export const OrganizationNameClassName = css`
  font-weight: 600;
`;

export const ContentClassName = css`
  display: flex;
  flex-direction: column;
  width: 300px;

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const OrganizationItemClassName = css`
  align-items: flex-start;
  white-space: break-spaces;

  &:hover,
  &:active {
    background-color: initial !important;
    box-shadow: none !important;
    cursor: default;
  }
`;
